import { WITHDRAW_STATUS } from "../../../../pages/withdraws/constants";
import { IApiResponse } from "../../models";

export interface IWithdrawalResponse extends IApiResponse {
  data: IWithdrawResponseData;
}

export interface IWithdrawResponseData {
  content: IWithdrawBody[];
  empty: boolean;
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  totalElements: number;
  totalPages: number;
}

export enum WithdrawalExecutorType {
  SINGLE_VIEW = "SINGLE_VIEW",
  MANUAL = "MANUAL",
}

export interface ExecuteWithdrawBody {
  withdrawalExecutorType: WithdrawalExecutorType;
  gatewayPaymentId?: string;
  transactionDate?: string;
}
export interface IWithdrawBody {
  id: number;
  beneficiaryId: number;
  beneficiaryName: string;
  createdAt: string;
  amount: number;
  status: WITHDRAW_STATUS;
}

export interface IWithdrawalItem {
  title: string;
  contractId: string;
  amount: number;
}

export interface IWithdrawalDetailsResponse extends IApiResponse {
  data: IWithdrawDetailsResponseData;
}

export interface IWithdrawDetailsBank {
  id?: number | null;
  iban: string;
  accountNumber?: number | null;
  currency?: string | null;
  beneficiaryName: string;
  bank: {
    id?: number | null;
    arabicName: string;
    englishName: string;
    abbreviation: string;
    swiftCode: string;
  };
  defaultAccount?: boolean | null;
  // International accounts (party outside KSA) — see setup/util/internationalBank.ts.
  international?: boolean;
  country?: string;
  bankName?: string;
  swiftCode?: string;
  branchName?: string;
  beneficiaryAddress?: string;
  document?: {
    bucketName?: string;
    objectName?: string;
    fileName?: string;
    url?: string;
  } | null;
}
export interface IWithdrawDetailsResponseData {
  id: number;
  beneficiaryId: number;
  beneficiaryName: string;
  createdAt: string;
  totalAmount: number;
  status: WITHDRAW_STATUS;
  numberOfTransactions: number;
  cashOutReferenceNumber: string | null;

  bank?: IWithdrawDetailsBank;
  withdrawalNumber: string;
  withDrawlItems: {
    content: IWithdrawalItem[];
    empty: boolean;
    first: boolean;
    last: boolean;
    number: number;
    numberOfElements: number;
    totalElements: number;
    totalPages: number;
  };
}

export interface IWithdrawalExecutionResponse extends IApiResponse {
  data: IWithdrawExecutionResponseData;
}

export interface IWithdrawExecutionResponseData {
  msg: string;
  success: boolean;
}
